import { Chip, Stack } from "@mui/material";
import React from "react";

export type TableCellChipProps = {
  data: any;
  color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
};

const TableCellChip: React.FC<TableCellChipProps> = (props) => {
  const { color = "default" } = props;

  let values = props.data ? (Array.isArray(props.data.value) ? props.data.value : [props.data.value]) : [];

  return (
    <>
      <Stack direction="row" sx={{ flexWrap: "wrap", gap: 0.5 }}>
        {values.map((v: string, index) => {
          return v !== "" && <Chip key={index} label={v} size="small" color={color} />;
        })}
      </Stack>
    </>
  );
};

export default TableCellChip;
